// NPM Imports
import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Internal Imports
import { IMAGE_URLS } from "../../../constants";

const { STAR } = IMAGE_URLS;

export default function AddOptionToClauseBtnUpgrade(props) {
  return (
    <Fragment>
      <Tooltip
        placement="top"
        overlay="Use this feature to add variation options to this clause in the form mode."
        align={{ offset: [0, 3] }}>
        <span
          className="add-clause-btn add-option-to-this-clause-btn"
          data-test="addoptiontoclausebtn-add-option-to-this-clause-btn"
          onMouseDown={() =>
            props.toggleUpgradePopup("showAddClauseUpgradePopup", true)
          }
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}>
          <i>
            <FontAwesomeIcon icon={["far", "layer-plus"]} />
          </i>
          Add Clause Field &nbsp; <img src={STAR} alt="star" />
        </span>
      </Tooltip>
    </Fragment>
  );
}
